









































import BaseComponent from '@/components/base-component.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import * as service from '@/services/pending-prescriptions';
import * as resize from '@/subjects/resize';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import PendingPrescriptionStatusChip from './pending-prescription-status-chip.vue';

@Component({
  components: {
    ListMessages,
    PendingPrescriptionStatusChip
  }
})
export default class PendingPrescriptionHistoryDetailsButton extends BaseComponent {
  @Prop()
  public id;
  @Prop()
  public nomePaciente;
  @Prop()
  public ticketZendesk;

  public histHeaders: any = [
    { text: 'Data', value: 'data', sortable: false },
    { text: 'Usuário', value: 'usuario', sortable: false },
    { text: 'Status', value: 'status', sortable: false },
    { text: 'Justificativa', value: 'justificativa', sortable: false }
  ];

  private historicoExibindo: any[] = [];
  private historicoError: boolean = false;
  private carregandoHistorico: boolean = false;

  smallScreen: boolean = resize.isXsOrSmSizeScreen();

  public buscarHistorico(): void {
    this.historicoError = false;
    this.carregandoHistorico = true;

    this.historicoExibindo = [];
    this.addSubsc(
      service.listPendingPrescriptionHistory(this.id).subscribe(
        (lista) => {
          this.carregandoHistorico = false;
          this.historicoExibindo = lista;
        },
        (error) => {
          this.carregandoHistorico = false;
          this.historicoError = true;
        }
      )
    );
  }
}
